import { RouteType } from "routes/types";
import { lazy } from "react";

const Element = lazy(() => import("./index"));

const route: RouteType = {
  id: 1600,
  parentId: 1000, // Make it a child of Info route
  name: "DraftAccess",
  label: "Draft Access",
  path: "draftAccess",
  element: Element,
  user: false, // Allow access without login - component handles auth
  hidden: true,
};

export default route;
